<div class="d-flex flex-column min-vh-100 error shadow">
    <!-- page content -->
    <main class="flex-grow-1 d-flex align-items-center justify-content-center">
        <div class="text-center p-4">

            <div class="logo mb-5">
                <img class="col-12" src="/assets/img/primary-logo.svg"/>
            </div>

            <div class="d-flex justify-content-center my-4">
                <svg width="85" height="73" viewBox="0 0 85 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M83.5621 62.7344L48.5664 3.42188C45.8871 -1.14062 39.1259 -1.14062 36.4286 3.42188L1.44919 62.7344C-1.24317 67.2806 2.11023 73 7.5066 73H77.4982C82.8731 73 86.2365 67.2969 83.5621 62.7344ZM38.5582 22.1607C38.5582 20.0017 40.3219 18.25 42.4958 18.25C44.6697 18.25 46.4335 20.0098 46.4335 22.1607V43.0179C46.4335 45.1769 44.6697 46.9286 42.6435 46.9286C40.6172 46.9286 38.5582 45.185 38.5582 43.0179V22.1607ZM42.4958 62.5714C39.6476 62.5714 37.3375 60.2771 37.3375 57.4484C37.3375 54.6196 39.646 52.3254 42.4958 52.3254C45.3457 52.3254 47.6541 54.6196 47.6541 57.4484C47.6476 60.2739 45.3506 62.5714 42.4958 62.5714Z" fill="#FFA500"/>
                </svg>
            </div>

            <h1 class="error-title">
                Oops! We couldn't find<br>your receipt
            </h1>

            <p class="error-message">
                Check that you have scanned the QR code properly or ask the merchant to re-generate the receipt code.
            </p>
        </div>
    </main>

    <div class="row align-items-center receipt-footer">
        <div class="col-7">
            <div class="ml-3 mb-1 text-white small">Powered by</div>
            <img class="col-12" src="/assets/img/f-logo.svg"/>
        </div>
        <div class="col-5 d-flex justify-content-end pr-4">
            <a href="https://supersweet.ai/" class="arrow-link text-white" target="_blank">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="white" stroke-opacity="0.2"/>
                    <path d="M25.8115 15.7929L33.668 23.2305C33.88 23.4311 34 23.7091 34 23.9999C34 24.2908 33.88 24.5684 33.668 24.7694L25.8115 32.2069C25.3832 32.6109 24.7053 32.5957 24.2964 32.171C23.8877 31.7504 23.9031 31.0752 24.3327 30.6684L30.2563 25.0637H15.0718C14.4803 25.0637 14 24.5873 14 24.0007C14 23.4141 14.4803 22.9386 15.0718 22.9386H30.2535L24.3299 17.3339C23.9009 16.9263 23.8876 16.2511 24.2938 15.8292C24.7044 15.4042 25.3428 15.3892 25.8115 15.7929Z" fill="white"/>
                </svg>
            </a>
        </div>
    </div>
    <img class="mh-12" src="/assets/img/supersweet-ribbon.png"/>
</div>